import React from 'react'
import PropTypes from 'prop-types'
import StatusBadge from 'components/atoms/status-badge'
import { CURATION_STATUS } from 'domains/merchant-inbound-item/constants'


const propTypes = {
  curation_status: PropTypes.string.isRequired
}

/**
 * To give nice look on Merchant Inbound Item `curation_status`.
 * It maps `curation_status` to certain style and pass to `StatusBadge`.
 * @param {string} curation_status
 */
const MerchantInboundItemCurationStatusBadge = ({ curation_status }) => {

  const colorMap = {
    [CURATION_STATUS.PENDING]   : 'warning',
    [CURATION_STATUS.COMPLETED] : 'success'
  }

  const color = colorMap[curation_status] || 'default'

  return <StatusBadge color={ color } label={ curation_status } />
}

MerchantInboundItemCurationStatusBadge.propTypes = propTypes

export default MerchantInboundItemCurationStatusBadge
